import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableHeader,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import TriggersEmpty from "../components/TriggersEmpty";

export default function WhatsappTriggersTable(props) {
  const { whatsappTriggers, onEdit, onDelete, showActions } = props;

  if (whatsappTriggers.length === 0) {
    return <TriggersEmpty />;
  }

  return (
    <Table>
      <TableHead>
        <TableHeader>Event Name</TableHeader>
        <TableHeader>Phone Number</TableHeader>
        <TableHeader>Template</TableHeader>
        {showActions && <TableHeader>Actions</TableHeader>}
      </TableHead>
      <TableBody>
        {whatsappTriggers.map((whatsappTrigger, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell>{whatsappTrigger.actionName}</TableCell>
              <TableCell>
                {whatsappTrigger.phoneNumber === ""
                  ? "Identified from Call"
                  : whatsappTrigger.phoneNumber}
              </TableCell>
              <TableCell>
                {whatsappTrigger.whatsAppTemplateDetails.templateName}
              </TableCell>
              {showActions && (
                <TableCell>
                  <div className="flex gap-x-2">
                    <Button
                      outline
                      onClick={() =>
                        onEdit({
                          isOpen: true,
                          item: whatsappTrigger,
                          index: idx,
                        })
                      }
                    >
                      <PencilIcon />
                    </Button>
                    <Button
                      outline
                      onClick={() =>
                        onDelete({
                          isOpen: true,
                          item: whatsappTrigger,
                          index: idx,
                        })
                      }
                    >
                      <TrashIcon />
                    </Button>
                  </div>
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
